module.exports = __webpack_public_path__ + "static/banner_dati.jpg";